import React from 'react';

const Home: React.FC<{ strokeColor?: string }> = ({ strokeColor }) => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25 18.2143H5.625V12.5C5.625 12.1762 5.73281 11.9048 5.94844 11.6857C6.16406 11.4667 6.43125 11.3571 6.75 11.3571H11.25C11.5688 11.3571 11.8359 11.4667 12.0516 11.6857C12.2672 11.9048 12.375 12.1762 12.375 12.5V18.2143H15.75V7.92857L9 2.78571L2.25 7.92857V18.2143ZM0 18.2143V7.92857C0 7.56667 0.0796875 7.22381 0.239063 6.9C0.398438 6.57619 0.61875 6.30952 0.9 6.1L7.65 0.957143C8.04375 0.652381 8.49375 0.5 9 0.5C9.50625 0.5 9.95625 0.652381 10.35 0.957143L17.1 6.1C17.3813 6.30952 17.6016 6.57619 17.7609 6.9C17.9203 7.22381 18 7.56667 18 7.92857V18.2143C18 18.8429 17.7797 19.381 17.3391 19.8286C16.8984 20.2762 16.3687 20.5 15.75 20.5H11.25C10.9312 20.5 10.6641 20.3905 10.4484 20.1714C10.2328 19.9524 10.125 19.681 10.125 19.3571V13.6429H7.875V19.3571C7.875 19.681 7.76719 19.9524 7.55156 20.1714C7.33594 20.3905 7.06875 20.5 6.75 20.5H2.25C1.63125 20.5 1.10156 20.2762 0.660938 19.8286C0.220313 19.381 0 18.8429 0 18.2143Z"
        fill={strokeColor ? strokeColor : "#666666"} />
    </svg>

  )
}



export default Home